import React, { useEffect, useState } from 'react';
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { SidebarReportClose } from '../../../../store/softSlice';
import AppURL from '../../../../widgets/AppURL';
import { fetchDataFromApi, postDataToTheServer } from '../../../../widgets/api';
import { FiscalYearOptions } from '../../../../widgets/Options';
import { FormatDate, NepaliACDateFormat } from '../../../../widgets/DateFormat';
import { ToastError } from '../../../../widgets/ToastMessage';
import ReportHeading from '../../../../widgets/ReportHeading';
import DefaultSelectOptionBox from '../../../../widgets/DefaultSelectBox';
import { ClearBtn, SearchBtn } from '../../../../widgets/AppBtn';
import InputNumberBox from '../../../../widgets/InputNumberBox';
import { Account_Report_From_To_Date, AccountTrialBalanceRptListView } from '../../../../store/accountSlice';
import SelectionBox from '../../../../widgets/SelectionBox';
import Loading from '../../../../widgets/Loading';

const AssetsRptFormView = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { menu_list } = useSelector((state) => state?.software);
    const CurrentDate = menu_list?.np_date;
    const FromDateFiscal = menu_list?.current_fiscal?.from_date_n;
    const CloseDispatch = () => {
        dispatch(SidebarReportClose({ "action": false }));
    }
    const [isLoading, setOnLoading] = useState(false);
    const [onManageFiscalYear, setOnFiscalYear] = useState([]);
    const fetchDataBalanceSheet = async () => {
        try {
            await fetchDataFromApi(AppURL.AccountsURL + "account-fiscal-year-date-list-view/").then((res) => {
                setOnFiscalYear(res);
                // Filter out the data where is_current_fiscal is true
                const currentFiscalYearData = res?.data?.filter(item => item?.is_current_fiscal === true);
                // Assuming currentFiscalYearData contains only one item, set the state accordingly
                if (currentFiscalYearData?.length > 0) {
                    setFieldValue('fiscal_year_name', currentFiscalYearData[0]?.fiscal_year_id);
                } else {
                    // Handle case where no current fiscal year data is found
                    setFieldValue('fiscal_year_name', 0);
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    const FiscalYearOption = FiscalYearOptions(onManageFiscalYear?.data);

    useEffect(() => {
        fetchDataBalanceSheet();
    }, []);

    const initialValues = {
        fiscal_year_name: "",
        from_date: FromDateFiscal,
        to_date: CurrentDate,
        branch_id: "",
    }
    const { values, handleChange, handleBlur, handleSubmit, errors, touched, setFieldValue, isSubmitting } =
        useFormik({
            initialValues: initialValues,
            enableReinitialize: true,
            onSubmit: async (values, action) => {
                setOnLoading(true);
                try {
                    const formData = new FormData();
                    formData.append("from_date", values.from_date);
                    formData.append("to_date", values.to_date);
                    await postDataToTheServer(AppURL.AccountsURL + `account-assets-report-create-list-view/`, formData).then((res) => {
                        CloseDispatch();
                        dispatch(AccountTrialBalanceRptListView(res));
                        setOnLoading(false);
                        navigate("/account-assets-report-list-view");
                        dispatch(Account_Report_From_To_Date({ from_date: values.from_date, to_date: values.to_date }));
                    });
                } catch (error) {
                    console.log(error);
                }
            },
        });

    return (
        <div className=''>
            <ReportHeading heading="Asset Reports" />
            <div className='mt-4'>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xl={12} lg={12} xs={12} sm={12} md={12}>
                            <SelectionBox name="fiscal_year_name" label="Fiscal Year" options={FiscalYearOption} value={values.fiscal_year_name} optionSelect={(fieldName, data) => {
                                console.log(data)
                                setFieldValue(fieldName, data.value);
                                setFieldValue('from_date', data.from_date_n);
                                setFieldValue('to_date', data.to_date_n);
                            }}
                                handleBlur={handleBlur}
                                touched={touched.fiscal_year_name}
                                errors={errors.fiscal_year_name}
                                required={true} />


                        </Grid>
                        <Grid item xl={12} lg={12} xs={12} sm={12} md={12}>
                            <InputNumberBox name="from_date" value={values.from_date} disabled={false} handleChange={handleChange} mask="9999/99/99" required={true} label={"From Date"} />
                        </Grid>

                        <Grid item xl={12} lg={12} xs={12} sm={12} md={12}>
                            <InputNumberBox name="to_date" value={values.to_date} disabled={false} handleChange={handleChange} mask="9999/99/99" required={true} label={"To Date"} />
                        </Grid>
                    </Grid>
                    <div className='flex justify-between mt-4'>
                        <ClearBtn type="button" onClick={CloseDispatch} /> <SearchBtn type="submit" />
                    </div>
                </form>
            </div>
            <Loading isSubmitting={isSubmitting} />
        </div>
    )
}

export default AssetsRptFormView